import PropTypes from 'prop-types';
import {
  BoundNew,
  CabinBaggageTripSummary,
  CheckedBaggageSummary,
  FareRule,
  TripCharacteristics,
  PriceFormat,
  TripChange,
} from '@eti/types';

export const propTypes = {
  anyTouched: PropTypes.bool,
  brand: PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
  }),
  bounds: PropTypes.arrayOf(BoundNew),
  cadillac: PropTypes.shape({
    filename: PropTypes.string,
    siteKey: PropTypes.string,
    url: PropTypes.string,
  }),
  change: PropTypes.func,
  cabinBaggageTripSummary: CabinBaggageTripSummary,
  cartId: PropTypes.string,
  cartState: PropTypes.string,
  chargeCurrencyPriceFormat: PriceFormat,
  checkedBaggageSummary: CheckedBaggageSummary,
  customerEmail: PropTypes.string,
  customerPhone: PropTypes.string,
  discountAmount: PropTypes.number,
  fareRules: PropTypes.arrayOf(FareRule),
  fillForm: PropTypes.func,
  form: PropTypes.string,
  isValid: PropTypes.bool,
  isPriceChangeDeclined: PropTypes.bool,
  handleSubmit: PropTypes.func,
  hide: PropTypes.func,
  higherText: PropTypes.string,
  history: PropTypes.objectOf(PropTypes.any),
  restoreCartUrl: PropTypes.string,
  triggerPayment: PropTypes.func,
  isOtherChargeCurrency: PropTypes.bool,
  isMultiStop: PropTypes.bool,
  onAcceptTripChange: PropTypes.func,
  onDeclineTripChange: PropTypes.func,
  paymentLinkCartId: PropTypes.string,
  paymentMethods: PropTypes.arrayOf(PropTypes.object),
  preloadReceiptPage: PropTypes.func,
  populatePriceChangeDisplayed: PropTypes.func,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      numberOfUnits: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      price: PropTypes.number,
      title: PropTypes.string,
    }),
  ),
  serviceFee: PropTypes.shape({
    currency: PropTypes.shape({
      code: PropTypes.string,
      exponent: PropTypes.number,
      name: PropTypes.string,
    }),
    value: PropTypes.number,
  }),
  bundles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      optionId: PropTypes.string,
      price: PropTypes.number,
      products: PropTypes.arrayOf(PropTypes.object),
      title: PropTypes.string,
    }),
  ),
  refetchPaymentQuery: PropTypes.func,
  refetchCart: PropTypes.func,
  reset: PropTypes.func,
  headerAndInfoHeight: PropTypes.number,
  subtotalPrice: PropTypes.number,
  transactionId: PropTypes.string,
  travelerPrices: PropTypes.arrayOf(
    PropTypes.shape({
      ageType: PropTypes.string,
      firstName: PropTypes.string,
      fullName: PropTypes.string,
      lastName: PropTypes.string,
      markup: PropTypes.number,
      price: PropTypes.number,
      quantity: PropTypes.number,
      totalPrice: PropTypes.number,
      totalPriceSum: PropTypes.number,
      vat: PropTypes.number,
    }),
  ),
  travelers: PropTypes.arrayOf(
    PropTypes.shape({
      ageType: PropTypes.string,
      birthDate: PropTypes.string,
      firstName: PropTypes.string,
      gender: PropTypes.string,
      id: PropTypes.string,
      lastName: PropTypes.string,
      name: PropTypes.string,
      passportNumber: PropTypes.string,
      products: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
          quantity: PropTypes.number,
        }),
      ),
    }),
  ),
  tripCharacteristics: PropTypes.arrayOf(TripCharacteristics),
  tripChanges: PropTypes.arrayOf(TripChange),
};
